import { defineComponent as _defineComponent } from 'vue'
import { ModalWrapper } from '@/shared/ui/modals'
import { eventApi, EventDB } from '@/enitites/event'
import { computed } from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventCancel',
  props: {
    event: null
  },
  emits: ["saveAsDraft"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'saveAsDraft'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  event: EventDB
};

const router = useRouter()



const isShowCancelEventCreation = computed(() => store.state.isShowCancelEventCreation)

async function removeEvent() {
  const resp = await eventApi.deleteEvent(props.event.id)
  if (resp) {
    await store.dispatch('toggleCancelEventCreation')
    await router.push({ name: 'EventsPage' })
  }
}

function saveAsDraftEvent() {
  emit('saveAsDraft')
  store.dispatch('toggleCancelEventCreation')
}

return { __sfc: true,router, emit, props, isShowCancelEventCreation, removeEvent, saveAsDraftEvent, ModalWrapper, store }
}

})